<template>
  <div class="live-cut">
    <img src="https://images.snsports.cn/livecut-intro.png" />
    <!-- <img src="https://images.snsports.cn/FkIvKXL_V9NVXPpYqHuknsU94QLT" class="img" /> -->
    <div class="footer-box">
      <div class="off-btn-item pop" @click="goTrial">
        <div>我想试用</div>
      </div>
      <div v-if="getType()" class="off-btn-item pop" @click="openDialog">
        如何获取应用
      </div>
      <div v-else class="off-btn-item pop" @click="download">
        点击下载
      </div>
    </div>
    <div class="overlay" v-if="show" @click="show = false">
      <img src="https://images.snsports.cn/FqiLwwEb9BLjtwpfjnd73hPktaZm" />
    </div>
  </div>
</template>

<script>
import { getAppPath, varConfig, AppType } from '@/utils'
import Vue from 'vue'
import { Dialog, Toast } from 'vant'
// 全局注册
Vue.use(Dialog).use(Toast)
export default {
  data() {
    return {
      show: false
    }
  },
  mounted() {
    this.shareData = {
      title: '斑马有镜头智能AI运动直播相机',
      abstract: 'AI自动运镜 记录你的运动人生',
      link: this.getShareLink(),
      image: 'https://images.snsports.cn/Ft5_kQFGQny1-uzFvqhx1cOp28sL'
    }
    this.wxShare(this.shareData)
  },
  methods: {
    getShareLink: function () {
      const arr = window.location.href.split('index.html')
      return arr[0] + 'index.html#/live-cut?v=1'
    },
    goTrial() {
      const path = getAppPath('webapplt')
      const url = `${varConfig.siteUrl}/${path}/index/index.html#/reservation?type=3&result=AI运动相机&radio=体育场馆`
      window.location.href = url
    },
    getType() {
      return AppType.isInAndroid() && AppType.isInApp() // 如果是在安卓手机中的APP环境返回true
    },
    openDialog() {
      Dialog.confirm({
        title: '提示',
        message: '复制下载链接，粘贴至手机浏览器地址栏下载安装应用',
        confirmButtonText: '点击复制链接',
        cancelButtonText: '我知道了'
      })
        .then(() => {
          // on confirm
          const textarea = document.createElement('textarea')
          textarea.value = 'https://images.snsports.cn/m/livecut-release.apk'
          textarea.style.position = 'fixed' // 避免在页面上滚动
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
          Toast('复制成功！')
        })
        .catch(() => {
          // on cancel
        })
    },
    download() {
      if (AppType.isInIOS()) {
        if (AppType.isInWeChat()) {
          this.show = true
        } else {
          window.location.href = 'https://apps.apple.com/cn/app/%E6%96%91%E9%A9%AC%E6%9C%89%E9%95%9C%E5%A4%B4/id6480511987'
        }
      } else if (AppType.isInAndroid()) {
        if (AppType.isInWeChat()) {
          this.show = true
        } else {
          let a = document.createElement('a')
          let href = 'https://images.snsports.cn/m/livecut-release.apk'
          a.href = href
          document.body.appendChild(a)
          a.click()
          setTimeout(() => document.body.removeChild(a), 1000)
        }
      } else {
        Dialog.alert({
          title: '标题',
          message: '请在手机浏览器打开页面'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.live-cut {
  font-size: 0;
  position: relative;
  padding-bottom: 20px;
  background-color: #257BC0;

  img {
    width: 100%;
  }

  .img {
    position: absolute;
    top: 180vw;
    left: 60vw;
    width: 35vw;
    height: 35vw;
    z-index: 99;
  }

  .footer-box {
    position: fixed;
    bottom: 0;
    width: 100%;
    max-width: 480px;
    height: 30px;
    background: rgba(255, 255, 255, 0.8);
    padding: 12px 0;
    text-align: right;
    // padding-bottom: 16px;
    z-index: 99;

    .off-btn-item {
      display: inline-block;
      padding: 4px 17px;
      border-radius: 24px;
      color: #FFFFFF;
      cursor: pointer;

    }

    .pop {
      background: linear-gradient(180deg, #257BC0 0%, #008cff 100%);
      margin-right: 18px;
      font-size: 16px;
    }
  }

  .overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 99;
    text-align: right;

    img {
      width: 90%;
      margin-top: 100px;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/live-cut/index.vue